export default "__VITE_ASSET__CvPvOTrY__"